// import {
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalBody,
//   ModalFooter,
//   Button,
//   FormControl,
//   FormLabel,
//   Input,
//   Select,
//   VStack,
//   useToast
// } from "@chakra-ui/react";

// import { useEffect, useState } from "react";
// import { ZonaService } from "../../services/zona.service";

// const initialForm = {
//   numero: "",
//   descricao: "",
//   zona_id: ""
// };

// export default function FormModal({
//   isOpen,
//   onClose,
//   onSave,
//   initialData
// }: any) {
//   const toast = useToast();

//   const [zonas, setZonas] = useState<any[]>([]);
//   const [form, setForm] = useState(initialForm);
//   const [submitted, setSubmitted] = useState(false);

//   function reset() {
//     setForm(initialForm);
//     setSubmitted(false);
//   }

//   useEffect(() => {
//     async function load() {
//       const data = await ZonaService.findAll();
//       setZonas(data);
//     }

//     load();
//   }, []);

//   useEffect(() => {
//     if (isOpen) {
//       if (initialData) {
//         setForm(initialData);
//       } else {
//         reset();
//       }
//     }
//   }, [isOpen, initialData]);

//   function isInvalid(field: string) {
//     return submitted && !form[field];
//   }

//   function handleSave() {
//     setSubmitted(true);

//     if (!form.numero || !form.descricao || !form.zona_id) {
//       toast({
//         title: "Preencha todos os campos",
//         status: "error"
//       });
//       return;
//     }

//     onSave(form);
//     reset();
//   }

//   return (
//     <Modal isOpen={isOpen} onClose={onClose}>
//       <ModalOverlay />
//       <ModalContent>
//         <ModalHeader>
//           {initialData ? "Editar Sessão" : "Nova Sessão"}
//         </ModalHeader>

//         <ModalBody>
//           <VStack spacing={4}>
//             <FormControl isInvalid={isInvalid("numero")}>
//               <FormLabel>Número</FormLabel>
//               <Input
//                 value={form.numero}
//                 onChange={(e) =>
//                   setForm({ ...form, numero: e.target.value })
//                 }
//               />
//             </FormControl>

//             <FormControl isInvalid={isInvalid("descricao")}>
//               <FormLabel>Descrição</FormLabel>
//               <Input
//                 value={form.descricao}
//                 onChange={(e) =>
//                   setForm({ ...form, descricao: e.target.value })
//                 }
//               />
//             </FormControl>

//             <FormControl isInvalid={isInvalid("zona_id")}>
//               <FormLabel>Zona</FormLabel>
//               <Select
//                 value={form.zona_id}
//                 onChange={(e) =>
//                   setForm({ ...form, zona_id: e.target.value })
//                 }
//               >
//                 <option value="">Selecione</option>
//                 {zonas.map((z) => (
//                   <option key={z.id} value={z.id}>
//                     {z.numero} - {z.descricao}
//                   </option>
//                 ))}
//               </Select>
//             </FormControl>
//           </VStack>
//         </ModalBody>

//         <ModalFooter>
//           <Button mr={3} onClick={onClose}>
//             Cancelar
//           </Button>

//           <Button colorScheme="blue" onClick={handleSave}>
//             Salvar
//           </Button>
//         </ModalFooter>
//       </ModalContent>
//     </Modal>
//   );
// }

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Select,
  VStack,
  useToast,
} from "@chakra-ui/react";

import axios from "axios";
import { useEffect, useState } from "react";
import { ZonaService } from "../../services/zona.service";

const initialForm = {
  numero: "",
  descricao: "",
  zona_id: "",
  cep: "",
  endereco: "",
  numero_endereco: "",
  bairro: "",
  cidade: "",
  uf: "",
};

function formatCEP(value: string) {
  const cleaned = value.replace(/\D/g, "");
  if (cleaned.length <= 5) return cleaned;
  return `${cleaned.slice(0, 5)}-${cleaned.slice(5, 8)}`;
}

export default function FormModal({
  isOpen,
  onClose,
  onSave,
  initialData,
}: any) {
  const toast = useToast();

  const [zonas, setZonas] = useState<any[]>([]);
  const [form, setForm] = useState(initialForm);
  const [submitted, setSubmitted] = useState(false);

  function reset() {
    setForm(initialForm);
    setSubmitted(false);
  }

  useEffect(() => {
    async function loadZonas() {
      const data = await ZonaService.findAll();

      const normalizedRows = Array.isArray(data)
        ? data
        : Array.isArray((data as any)?.data)
          ? (data as any).data
          : [];

      setZonas(normalizedRows);
      // setZonas(data);
    }
    loadZonas();
  }, []);

  useEffect(() => {
    if (isOpen) {
      if (initialData) {
        setForm({ ...initialForm, ...initialData });
      } else {
        reset();
      }
    }
  }, [isOpen, initialData]);

  function isInvalid(field: string) {
    return submitted && !form[field];
  }

  async function buscarCEP(cep: string) {
    const cleaned = cep.replace(/\D/g, "");
    const formatted = formatCEP(cep);
    setForm({ ...form, cep: formatted });

    if (cleaned.length !== 8) return;

    try {
      const { data } = await axios.get(`https://viacep.com.br/ws/${cleaned}/json/`);
      if (data.erro) return;

      setForm((prev: any) => ({
        ...prev,
        cep: formatted,
        endereco: data.logradouro || "",
        bairro: data.bairro || "",
        cidade: data.localidade || "",
        uf: data.uf || "",
      }));
    } catch {
      toast({ title: "Erro ao buscar CEP", status: "error" });
    }
  }

  function handleSave() {
    setSubmitted(true);

    if (!form.numero || !form.descricao || !form.zona_id) {
      toast({ title: "Preencha todos os campos obrigatórios", status: "error" });
      return;
    }

    onSave(form);
    reset();
    onClose();
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{initialData ? "Editar Sessão" : "Nova Sessão"}</ModalHeader>

        <ModalBody>
          <VStack spacing={4}>
            <FormControl isInvalid={isInvalid("numero")}>
              <FormLabel>Número *</FormLabel>
              <Input
                value={form.numero}
                onChange={(e) => setForm({ ...form, numero: e.target.value })}
              />
            </FormControl>

            <FormControl isInvalid={isInvalid("descricao")}>
              <FormLabel>Descrição *</FormLabel>
              <Input
                value={form.descricao}
                onChange={(e) => setForm({ ...form, descricao: e.target.value })}
              />
            </FormControl>

            <FormControl isInvalid={isInvalid("zona_id")}>
              <FormLabel>Zona *</FormLabel>
              <Select
                value={form.zona_id}
                onChange={(e) => setForm({ ...form, zona_id: e.target.value })}
              >
                <option value="">Selecione uma zona</option>
                {zonas.map((z) => (
                  <option key={z.id} value={z.id}>
                    {z.numero} - {z.descricao}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel>CEP</FormLabel>
              <Input
                placeholder="00000-000"
                value={form.cep}
                onChange={(e) => buscarCEP(e.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Endereço</FormLabel>
              <Input
                value={form.endereco}
                onChange={(e) => setForm({ ...form, endereco: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Número</FormLabel>
              <Input
                value={form.numero_endereco}
                onChange={(e) => setForm({ ...form, numero_endereco: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Bairro</FormLabel>
              <Input
                value={form.bairro}
                onChange={(e) => setForm({ ...form, bairro: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Cidade</FormLabel>
              <Input
                value={form.cidade}
                onChange={(e) => setForm({ ...form, cidade: e.target.value })}
              />
            </FormControl>

            <FormControl>
              <FormLabel>UF</FormLabel>
              <Input
                value={form.uf}
                onChange={(e) => setForm({ ...form, uf: e.target.value })}
              />
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button mr={3} onClick={onClose}>
            Cancelar
          </Button>
          <Button colorScheme="blue" onClick={handleSave}>
            Salvar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}